import styled from 'styled-components'
import { Table, Button } from 'antd'
import { StyledModal as BaseModal, SecondaryButton } from '../styles'

export const StyledModal = styled(BaseModal)`
    & .ant-modal-footer {
        border-top: 1px solid #f0f0f0;
        padding: 12px 24px;
    }
`

export { SecondaryButton as CloseButton }

export const AttributeGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px 16px;
    background: #fafafa;
    border-radius: 8px;
    padding: 20px;
    margin-bottom: 24px;
    box-shadow: 3px 0px 20px rgba(0, 0, 0, 0.05);
`

export const Attribute = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`

export const AttributeLabel = styled.span`
    font-size: 11px;
    font-weight: 400;
    color: #424647;
    text-transform: uppercase;
    letter-spacing: 0.06em;
`

export const AttributeValue = styled.span`
    font-size: 14px;
    font-weight: 700;
    color: #171c2f;
`

export const SectionHeader = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 12px;
`

export const SectionLabel = styled.span`
    font-size: 12px;
    font-weight: 600;
    color: #424647;
    text-transform: uppercase;
    letter-spacing: 0.06em;
`

export const CountBadge = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background-color: #7BAD7E;
    color: #fff;
    font-size: 11px;
    font-weight: 600;
    border-radius: 10px;
    padding: 1px 8px;
    min-width: 22px;
`

export const EditButton = styled(Button)`
    border-radius: 6px;
    padding: 0 16px;
    height: 36px;
    background-color: #7BAD7E;
    border: none;
    color: white;
    font-weight: 500;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    transition: background-color 0.2s;

    &:hover,
    &:focus {
        background-color: #5F8C6C;
        border-color: transparent;
        color: white;
    }
`

export const DangerButton = styled(Button)`
    border-radius: 6px;
    padding: 0 16px;
    height: 36px;
    background-color: rgb(175, 35, 35);
    border: none;
    color: white;
    font-weight: 500;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    transition: background-color 0.2s;

    &:hover,
    &:focus {
        background-color: rgb(121, 24, 24);
        border-color: transparent;
        color: white;
    }

    & .anticon {
        color: white;
    }
`

export const StyledTable = styled(Table)`
    & .ant-table {
        border-radius: 8px;
        overflow: hidden;
        box-shadow: 3px 0px 20px rgba(0, 0, 0, 0.05);
    }
    & .ant-table-thead > tr > th {
        background: #f0f7f0;
        color: #424647;
        font-size: 11px;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.06em;
        border-bottom: 1px solid #d9ead9;
    }
    & .ant-table-tbody > tr > td {
        font-size: 13px;
        color: #171c2f;
        border-bottom: 1px solid #f5f5f5;
    }
    & .ant-table-tbody > tr:hover > td {
        background: #f7fbf7;
    }
    & .ant-table-tbody > tr:last-child > td {
        border-bottom: none;
    }
`